﻿import { FlagColor, SparkPoint } from "./ActivitiesTypes";

export function makeTrailing7() {
    const today = new Date();
    const days: { date: Date; key: string; label: string }[] = [];
    for (let i = 6; i >= 0; i--) {
        const d = new Date(today.getFullYear(), today.getMonth(), today.getDate() - i);
        const key = d.toISOString().slice(0, 10);
        const label = d.toLocaleDateString(undefined, { weekday: "short" });
        days.push({ date: d, key, label });
    }
    return days;
}

export function formatHeaderDate(d: Date | null, last?: Date | null): string {
    const effective = d ?? last ?? null;
    if (!effective) return "Date unknown";
    return effective.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
}

export function formatDurationFromHours(hours?: number | null): string {
    if (hours === undefined || hours === null || !isFinite(hours)) return "—";
    const totalMins = Math.max(0, Math.round(hours * 60));
    const h = Math.floor(totalMins / 60);
    const m = totalMins % 60;
    return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

export function buildSparkPath(data?: SparkPoint[] | null, width = 200, height = 50): string {
    const src = data || [];
    if (!src.length) return "";
    const ys = src.map((p) => p.hr).filter((n) => Number.isFinite(n));
    if (!ys.length) return "";
    const min = Math.min(...ys);
    const max = Math.max(...ys);
    const span = Math.max(1, max - min);
    const step = src.length > 1 ? width / (src.length - 1) : width;
    let dPath = "";
    for (let i = 0; i < src.length; i++) {
        const x = i * step;
        const y = height - ((src[i].hr - min) / span) * height;
        dPath += `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)} `;
    }
    return dPath.trim();
}

export function gradientClass(flag: FlagColor) {
    switch (flag) {
        case FlagColor.Green:
            return "bg-gradient-to-br from-emerald-500 to-emerald-600";
        case FlagColor.GreenAmber:
            return "bg-gradient-to-br from-lime-500 to-lime-600";
        case FlagColor.Amber:
            return "bg-gradient-to-br from-amber-500 to-amber-600";
        case FlagColor.Red:
            return "bg-gradient-to-br from-red-500 to-red-600";
        case FlagColor.DarkRed:
            return "bg-gradient-to-br from-orange-900 to-red-900";
        default:
            return "bg-gradient-to-br from-slate-500 to-slate-600";
    }
}

export function bandLabel(flag: FlagColor) {
    switch (flag) {
        case FlagColor.Green:
            return "Very Low / Healthy";
        case FlagColor.GreenAmber:
            return "Healthy Strain";
        case FlagColor.Amber:
            return "High Strain";
        case FlagColor.Red:
            return "Very High";
        case FlagColor.DarkRed:
            return "Risk Zone";
        default:
            return "N/A";
    }
}

export function getWeeklyScoreZone(score: number): string {
    if (score < 70) return "Too Low";
    if (score < 140) return "Maintenance";
    if (score < 250) return "Ideal Week";
    if (score < 350) return "Strong Week";
    if (score < 450) return "High Load";
    return "Too Much";
}

export function getMonotonyLabel(monotony: number): string {
    if (monotony === 0.0) return "No Training";
    if (monotony < 0.8) return "Very Variable";
    if (monotony < 1.5) return "Healthy Variation";
    if (monotony < 2.0) return "High Monotony";
    return "Risk Zone";
}

export function getStrainLabel(strain: number): string {
    if (strain <= 100) return "Very Low Strain";
    if (strain <= 250) return "Healthy Strain";
    if (strain <= 400) return "High Strain";
    if (strain <= 600) return "Very High Strain";
    return "Risk Zone";
}
